module.exports = __webpack_public_path__ + "img/act_icon_01.c286201.png";